export class FeesTab {
	passCardBrandFees = "true";
	flatRateIsRiseFree = "true";
	interchangePlusRevenueType = "0";
}
